import React, { FC } from 'react';
import { Col, FormGroup, FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import SelectInput from '../../../../../../components/library/inputs/select/SelectInput';

interface Props {
  label: string;
  noEmptyValue?: boolean;
  size: number;
  value: string | undefined;
  options: Array<{ text: string; value: string }> | undefined;
  onChange: (event: string) => void;
}

const SelectSetting: FC<Props> = ({ label, noEmptyValue, size, value, options, onChange }: Props) => {
  return (
    <FormGroup className={'form-group'} as={Col} size={size}>
      <FormLabel>
        <FormattedMessage id={label} />
      </FormLabel>
      <SelectInput
        noEmptyValue={noEmptyValue}
        options={options}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </FormGroup>
  );
};

export default SelectSetting;
